import { createAsyncThunk } from "@reduxjs/toolkit";
import isNull from "lodash/isNull";
import omitBy from "lodash/omitBy";

import { getProjectFinder } from "@/models";
import type { ProjectFinderParams } from "@/types";

export const fetchProjectFinder = createAsyncThunk(
  "project-finder/fetchProjectFinder",
  async (params: Partial<ProjectFinderParams>, { rejectWithValue }) => {
    const { uId } = params;

    try {
      const response = await getProjectFinder(uId);
      return omitBy(response, isNull);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
